import { render } from "./BXZ.vue?vue&type=template&id=73743e82&scoped=true"
import script from "./BXZ.vue?vue&type=script&lang=js"
export * from "./BXZ.vue?vue&type=script&lang=js"

import "./BXZ.vue?vue&type=style&index=0&id=73743e82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73743e82"]])

export default __exports__